import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import BoltIcon from "@mui/icons-material/Bolt";

/**
 * App users — what to act on today (design item 28). Each tile opens the list that fixes it.
 * Renders nothing when there is nothing to act on.
 */
export default function AppAttentionStrip({ cards, subscriptions, linkFor }) {
  const card = (label) => (cards || []).find((c) => c.label === label);
  const seg = (label) => Number((subscriptions || []).find((s) => s.label === label)?.value || 0);
  const failures = card("Payment Failures");

  const items = [
    {
      key: "failed",
      n: Number(failures?.value || 0),
      text: "failed card payments to chase",
      to: failures?.href || "/admin/mobile-users?tab=payments&payment_status=failed",
      Icon: CreditCardOffIcon, bg: "#FEE2E2", fg: "#B91C1C",
    },
    {
      key: "expired",
      n: seg("Expired"),
      text: "expired subscriptions to win back",
      to: linkFor?.("Expired"),
      Icon: EventBusyIcon, bg: "#FEF3C7", fg: "#B45309",
    },
    {
      key: "free",
      n: seg("Free") + seg("Trial"),
      text: "users on a free trial to convert",
      to: linkFor?.("Free"),
      Icon: BoltIcon, bg: "#EDE9FE", fg: "#3B2A9F",
    },
  ].filter((i) => i.n > 0 && i.to);

  if (!items.length) return null;

  return (
    <Paper sx={{ p: 1.5, mt: 2, borderRadius: 3, border: "1px solid #eef0f4", boxShadow: "none" }}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} alignItems={{ md: "center" }}>
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#111827", whiteSpace: "nowrap", px: 0.5 }}>
          Needs attention
        </Typography>
        {items.map(({ key, n, text, to, Icon, bg, fg }) => (
          <Box
            key={key}
            component={RouterLink}
            to={to}
            sx={{
              display: "flex", alignItems: "center", gap: 1, px: 1.5, py: 1, borderRadius: 2,
              background: bg, color: fg, textDecoration: "none", fontSize: 13, fontWeight: 600,
              "&:hover": { filter: "brightness(0.97)" },
            }}
          >
            <Icon sx={{ fontSize: 18 }} />
            <span><strong>{n.toLocaleString("en-GB")}</strong> {text}</span>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}
